export default __webpack_public_path__ + "static/media/DSC03526.b105ede8.JPG";